
define('template!webshopAttributesCategoryView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="toolbar">\n    <span class="toolbar-label">' +
((__t = ( _.i18n('attributeMatching.category', null, 'Category') )) == null ? '' : __t) +
'</span>\n    <div class="category-region"></div>\n    <span class="category-info am-hint"></span>\n    ' +
((__t = ( subHtml )) == null ? '' : __t) +
'\n    ' +
((__t = ( hideHtml )) == null ? '' : __t) +
'\n    <input type="text" class="product-search am-input" placeholder="' +
((__t = ( _.i18n('attributeMatching.searchProduct', null, 'Code or name') )) == null ? '' : __t) +
'"/>\n    <span class="toolbar-label">' +
((__t = ( _.i18n('attributeMatching.attribute', null, 'Attribute') )) == null ? '' : __t) +
'</span>\n    <select class="key am-select">\n        <option value="">' +
((__t = ( _.i18n('attributeMatching.allAttributes', null, 'All attributes') )) == null ? '' : __t) +
'</option>\n    </select>\n</div>\n<div class="assign">\n    <div class="values"></div>\n    <div class="actions off">\n        <label><input type="radio" name="scope" class="scope-selected" checked/> ' +
((__t = ( _.i18n('attributeMatching.scopeSelected', null, 'Selected products') )) == null ? '' : __t) +
'</label>\n        <label><input type="radio" name="scope" class="scope-all"/> ' +
((__t = ( _.i18n('attributeMatching.scopeAll', null, 'Whole category (visible / found products)') )) == null ? '' : __t) +
'</label>\n        <span class="count">(<span class="selected-count">0</span>)</span>\n        <span class="action add" data-mode="ADD">' +
((__t = ( _.i18n('attributeMatching.add', null, 'Add') )) == null ? '' : __t) +
'</span>\n        <span class="action remove-values" data-mode="REMOVE">' +
((__t = ( _.i18n('attributeMatching.remove', null, 'Remove') )) == null ? '' : __t) +
'</span>\n        <span class="action replace" data-mode="REPLACE">' +
((__t = ( _.i18n('attributeMatching.replace', null, 'Replace') )) == null ? '' : __t) +
'</span>\n    </div>\n    ' +
((__t = ( legendHtml )) == null ? '' : __t) +
'\n</div>\n<div class="table">\n    <div class="row head">\n        <div class="col-check"><input type="checkbox" class="check-all"/></div>\n        <div class="col-product">' +
((__t = ( _.i18n('common.product', null, 'Product') )) == null ? '' : __t) +
'</div>\n        <div class="col-values">' +
((__t = ( _.i18n('attributeMatching.valuesTitle', null, 'Values') )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="rows"></div>\n</div>\n<div class="am-pager"></div>\n';

}
return __p
};});

